<template>
  <b-overlay :show="loading">
    <div class="d-flex justify-content-center align-items-center">
      <div v-tooltip="'Ver detalle'">
        <b-button
          variant="secondary"
          class="btn-icon rounded-circle p-3"
          size="sm"
          v-on:click="onOptionDetailAuctionBatchHistory(auctionBatch)"
          data-cy="details"
        >
          <feather-icon icon="SearchIcon"/>
        </b-button>
      </div>
      <slot
        name="action-list"
        v-bind:auctionBatch="auctionBatch"
      >
        <div v-tooltip="'Desplegar acciones'">
          <b-dropdown
            v-has-permission="'ED185'"
            variant="link"
            no-caret
            right
          >
            <template #button-content>
              <feather-icon
                data-cy="gear-button"
                width="24px"
                height="24px"
                icon="SettingsIcon"
                class="align-middle text-body"
              />
            </template>
            <CheckPermission permission="ED166">
              <b-dropdown-item
                v-on:click="onOptionAuctionBatchHistoryBinnacle(auctionBatch)"
                data-cy="binnacle"
              >
                <vs-icon icon="list"/>
                Bitácora
              </b-dropdown-item>
            </CheckPermission>
          </b-dropdown>
        </div>
      </slot>
    </div>
    <b-modal
      :id="`batch-detail-${auctionBatch.loteId}`"
      :title="`Detalles del Lote Nº ${auctionBatch.folio}`"
      no-close-on-backdrop
      :ref="`batch-detail-${auctionBatch.loteId}`"
      size="lg"
      hide-footer
    >
      <BatchDetail :batch="auctionBatch"/>
    </b-modal>
    <ModalBinnacle
      :batch="auctionBatch"
      :title="`Bitácora del Lote Nº ${auctionBatch.folio}`"
      :id="`binnacle-${auctionBatch.loteId}`"
      :ref="`binnacle-${auctionBatch.loteId}`"
    />
  </b-overlay>
</template>
<script>

import { mapActions } from 'vuex';

import BatchDetail from '@/febos/aduanas/batches/views/components/modals/BatchDetail';
import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import ModalBinnacle from '@/febos/aduanas/binnacles/ModalBinnacle';

export default {
  components: {
    BatchDetail,
    CheckPermission,
    ModalBinnacle
  },
  props: [
    'auctionBatch',
    'selectBatch'
  ],
  data() {
    return {
      view: this.$route.name,
      loading: false
    };
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    onOptionDetailAuctionBatchHistory(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-detail-${batch.loteId}`].show();
    },
    onOptionAuctionBatchHistoryBinnacle(batch) {
      this.selectBatch(batch);
      this.$refs[`binnacle-${batch.loteId}`].show(batch.loteId);
    }
  }
};

</script>
